import type { Evaluation } from '../types/evaluation'

/**
 * Cor do selo por kind, no vocabulário de cor do portal (as mesmas usadas nos
 * selos de tipo da Biblioteca) — não inventar hex novo.
 */
export const KIND_BADGE: Record<Evaluation['kind'], { label: string; className: string }> = {
  generic: { label: 'Questionário', className: 'bg-jacaranda' },
  socio_emotional: { label: 'Socioemocional', className: 'bg-manaca' }
}

export const countQuestions = (evaluation: Evaluation) =>
  evaluation.questions.filter(question => question.kind !== 'heading').length

/**
 * Uma linha só de contexto: nº de perguntas e tempo estimado. O aluno decide se
 * começa agora por esses dois números.
 */
export const buildSummary = (evaluation: Evaluation) => {
  const total = countQuestions(evaluation)
  const parts = [`${total} ${total === 1 ? 'pergunta' : 'perguntas'}`]

  if (evaluation.estimated_time) parts.push(evaluation.estimated_time)

  return parts.join(' · ')
}
